import React from 'react';
import { useTheme } from '../../../context/ThemeContext';

/**
 * Skeleton loader for StocksTable component
 * Displays placeholder content while data is loading
 */
const StocksTableSkeleton = () => {
  const { theme } = useTheme();

  return (
    <div
      className={`rounded-[6px] overflow-hidden ${
        theme === 'dark'
          ? 'bg-[#0F0F0F] shadow-[0_2px_5px_1px_rgba(175,175,175,0.1)]'
          : 'bg-white shadow-[0_2px_5px_1px_rgba(87,87,87,0.1)]'
      }`}
    >
      <div className="overflow-x-auto overflow-y-auto max-h-[600px]">
        <table className="w-full">
          <thead className={`sticky top-0 z-10 ${theme === 'dark' ? 'bg-[#0F0F0F]' : 'bg-white'}`}>
            <tr
              className={`border-b ${
                theme === 'dark' ? 'border-[#1F1F1F]' : 'border-[#EBEBEB]'
              }`}
            >
              <th className="px-3 py-3 text-left w-12">
                <div className="w-5 h-5 bg-n200 rounded animate-pulse"></div>
              </th>
              <th className={`px-4 py-3 text-left text-sm font-medium text-n500 min-w-[180px]`}>
                Stock
              </th>
              <th className={`px-4 py-3 text-right text-sm font-medium text-n500 min-w-[100px]`}>
                LTP
              </th>
              <th className={`px-4 py-3 text-right text-sm font-medium text-n500 min-w-[100px]`}>
                Change
              </th>
              <th className={`px-4 py-3 text-right text-sm font-medium text-n500 min-w-[120px]`}>
                Prev. Close
              </th>
              <th className={`px-4 py-3 text-right text-sm font-medium text-n500 min-w-[120px]`}>
                Volume
              </th>
              <th className={`px-4 py-3 text-right text-sm font-medium text-n500 min-w-[100px]`}>
                Exchange
              </th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: 10 }).map((_, index) => (
              <tr
                key={index}
                className={`border-b ${
                  theme === 'dark' ? 'border-[#1F1F1F]' : 'border-[#EBEBEB]'
                }`}
              >
                {/* Checkbox column */}
                <td className="px-3 py-3">
                  <div className="w-5 h-5 bg-n200 rounded animate-pulse"></div>
                </td>
                {/* Stock column */}
                <td className="px-4 py-3">
                  <div className="flex flex-col gap-2">
                    <div className="h-4 w-20 bg-n200 rounded animate-pulse"></div>
                    <div className="h-3 w-32 bg-n200 rounded animate-pulse"></div>
                  </div>
                </td>
                {/* LTP column */}
                <td className="px-4 py-3 text-right">
                  <div className="h-4 w-16 bg-n200 rounded animate-pulse ml-auto"></div>
                </td>
                {/* Change column */}
                <td className="px-4 py-3 text-right">
                  <div className="h-4 w-16 bg-n200 rounded animate-pulse ml-auto"></div>
                </td>
                {/* Prev. Close column */}
                <td className="px-4 py-3 text-right">
                  <div className="h-4 w-16 bg-n200 rounded animate-pulse ml-auto"></div>
                </td>
                {/* Volume column */}
                <td className="px-4 py-3 text-right">
                  <div className="h-4 w-20 bg-n200 rounded animate-pulse ml-auto"></div>
                </td>
                {/* Exchange column */}
                <td className="px-4 py-3 text-right">
                  <div className="h-3 w-12 bg-n200 rounded animate-pulse ml-auto"></div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StocksTableSkeleton;
